module.exports = __webpack_public_path__ + "img/icon_service.bf69a598.png";